import React from "react";
import Shadow from "../Shadow";
import RadioBox from "../forms/RadioBox";
import Plug from "./plug";
import { IView } from "../../../types";

const View = ({ shadowFalse, resetForm, shadow, data }) => {
  const views: IView[] = data;
  const reload = () => {
    shadowFalse(2);
    resetForm([
      "depth",
      "format",
      "formatMM1",
      "formatMM2",
      "processing",
      "processingValue",
    ]);
  };
  return views?.length ? (
    <div className={"bl_4_grid_item"}>
      {shadow && <Shadow />}
      <div className="calc_title_box">
        <div className="calc_title">Вид</div>
        {views.map((v) => (
          <RadioBox
            info={{ text: v.description, img: v.photo }}
            key={v.name}
            name={"view"}
            value={v.name}
            func={reload}
          />
        ))}
      </div>
    </div>
  ) : (
    <Plug reload={reload} shadow={shadow} />
  );
};

export default View;
